import { DEVICE_ID_SEARCH_PARAMS_KEY } from '../constants.mjs';

const getDeviceIdFromUrlParam = (urlSearchParamsString) => {
  const searchParams = new URLSearchParams(urlSearchParamsString);
  if (searchParams.has(DEVICE_ID_SEARCH_PARAMS_KEY)) {
    return searchParams.get(DEVICE_ID_SEARCH_PARAMS_KEY) ?? void 0;
  }
  return void 0;
};

export { getDeviceIdFromUrlParam };
//# sourceMappingURL=getDeviceIdFromUrlParam.mjs.map
